import {Component, Input, TemplateRef, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'modal-confirm-autofocus',
  templateUrl: './modal-confirm.component.html',
  styleUrls: ['./modal-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ModalConfirmAutofocus {
  @Input() data: ModalConfirmAutofocusData;
  callback: (boolean, string?) => any;

  get title() {
    return this.data?.title || "Danger";
  }

  get messagePoints() {
    return this.data?.messagePoints || [];
  }

  get points() {
    return this.data?.points || [];
  }

  get confirmText() {
    return this.data?.confirmText || "Ok";
  }

  get cancelText() {
    return this.data?.cancelText || "Cancel";
  }

  get reasonLabel() {
    return this.data?.reasonLabel || "Reason";
  }
}

export interface ModalConfirmAutofocusData {
  type: string;
  title: string;
  modalSize: null | 'sm' | 'lg' | 'xl';
  message: string;
  messagePoints: string[];
  messageSeperated: boolean;
  beforePointsMessage: string;
  points: string[];
  afterPointsMessage: string;
  question: string;
  confirmText: string;
  cancelText: string;
  withReason?: boolean;
  withReasonTextArea?: boolean;
  withChosableReason?: boolean;
  chosableMessage: string;
  chosableReasons: string[];
  chosableReasonFormatter: any;
  reasonLabel?: string;
  reason?: string;
  noBorder: boolean;
  alignHeaderBody: boolean;
  body: TemplateRef<any>;
}
